import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const PaymentPlansPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('plans');

  const subTabs = [
    { id: 'plans', label: 'Subscription Plans', icon: 'CreditCard' },
    { id: 'pricing', label: 'Pricing', icon: 'DollarSign' },
    { id: 'billing', label: 'Billing', icon: 'Receipt' }
  ];

  const mockPlans = [
    { id: 1, name: 'Basic', price: 999, interval: 'month', features: ['10 Listings', 'Basic Support'], active: true },
    { id: 2, name: 'Professional', price: 2499, interval: 'month', features: ['50 Listings', 'Priority Support', 'Analytics'], active: true },
    { id: 3, name: 'Enterprise', price: 4999, interval: 'month', features: ['Unlimited Listings', '24/7 Support', 'Custom Features'], active: true }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'plans':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-soft p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                <h3 className="font-heading font-semibold text-lg text-text-primary">
                  Subscription Plans
                </h3>
                <Button variant="primary" iconName="Plus" iconSize={16}>
                  Add Plan
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {mockPlans.map((plan) => (
                  <div key={plan.id} className="border border-border rounded-xl p-6 hover:border-primary-200 transition-colors">
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="font-heading font-semibold text-lg text-text-primary">
                        {plan.name}
                      </h4>
                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                        plan.active ? 'bg-success-100 text-success' : 'bg-gray-100 text-gray-600'
                      }`}>
                        {plan.active ? 'Active' : 'Inactive'}
                      </span>
                    </div>
                    
                    <div className="mb-4">
                      <span className="text-3xl font-bold text-text-primary">₹{plan.price}</span>
                      <span className="text-text-secondary">/{plan.interval}</span>
                    </div>
                    
                    <ul className="space-y-2 mb-6">
                      {plan.features.map((feature, index) => (
                        <li key={index} className="flex items-center text-sm text-text-secondary">
                          <Icon name="Check" size={16} className="text-success mr-2" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    
                    <div className="flex space-x-2">
                      <Button variant="outline" size="sm" className="flex-1">
                        Edit
                      </Button>
                      <Button variant="ghost" size="sm">
                        <Icon name="MoreVertical" size={16} />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      case 'pricing':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="DollarSign" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Pricing Configuration
              </h3>
              <p className="text-text-secondary mb-6">
                Manage pricing tiers and commission structures
              </p>
              <Button variant="outline" disabled>
                Configure Pricing
              </Button>
            </div>
          </div>
        );
      case 'billing':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Receipt" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Billing Management
              </h3>
              <p className="text-text-secondary mb-6">
                Handle subscriptions, invoices, and payments
              </p>
              <Button variant="outline" disabled>
                View Billing
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Payment Plans
        </h2>
        <p className="text-white/90">
          Manage subscription plans and pricing
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}
    </div>
  );
};

export default PaymentPlansPanel;